import type { HTMLAttributes } from 'react';
import classNames from 'classnames';

import type { GDPGarage } from '@/components/organisms/GDPGarageInfoCard';
import { GarageDetails } from '@/components/atoms/GarageDetails';
import styles from './index.module.scss';

interface GarageDetailsProps extends HTMLAttributes<HTMLDivElement> {
  readonly garage: GDPGarage;
  readonly translations: {
    readonly fixterCNDText: string;
  };
}

export function GarageDetailsSection({
  className,
  garage,
  translations: { fixterCNDText },
}: GarageDetailsProps): JSX.Element {
  const { addressText, servicesText, openingHoursText, isFixterGarage } = garage;

  return (
    <div className={classNames(styles.GarageDetailsSection, className)}>
      <GarageDetails iconId="travel/marker-pin-01" text={addressText} />
      <GarageDetails iconId="time/clock" text={openingHoursText} />
      <GarageDetails iconId="general/tool-02" text={servicesText} />
      {isFixterGarage && <GarageDetails iconId="travel/car-01" text={fixterCNDText} />}
    </div>
  );
}

GarageDetailsSection.displayName = 'GarageDetailsSection';
